<header
  class="mobile-header lg:hidden fixed top-0 start-0 end-0 bg-neutral-800 border-b border-neutral-700/30 z-50 h-16"
>
  <div class="flex items-center justify-between h-full px-4">
    <!-- Project Name -->
    <div class="flex items-center space-x-2">
      <img src="/assets/demis-logo-white.png" [attr.alt]="'navbar.logoAlt' | transloco" class="w-8 h-auto" />

      <!-- <div class="w-8 h-8 bg-gradient-to-tr from-primary-500 to-primary-600 rounded-lg flex items-center justify-center">
        <i class="pi pi-comment text-white text-sm"></i>
      </div> -->
      <span class="text-lg font-bold text-white">
        {{ 'header.siteName' | transloco }}
      </span>
    </div>

    <!-- Right Side Actions -->
    <div class="flex items-center space-x-2">
      <!-- Theme Toggle -->
      <button
        (click)="toggleTheme()"
        class="p-2 rounded-xl w-8 h-8 bg-neutral-700/70 hover:bg-neutral-600/90 transition-all duration-200 flex items-center justify-center"
        [attr.aria-label]="
          isDark
            ? ('header.theme.switchToLight' | transloco)
            : ('header.theme.switchToDark' | transloco)
        "
      >
        @if (isDark) {
          <i class="pi pi-sun text-amber-300 text-sm"></i>
        } @else {
          <i class="pi pi-moon text-neutral-300 text-sm"></i>
        }
      </button>

      <!-- User Avatar with Popover -->
      @if (currentUser) {
        <div class="relative">
          <button
            (click)="toggleUserPopover($event)"
            class="p-0 rounded-xl w-8 h-8 bg-neutral-700/70 hover:bg-neutral-600/90 transition-all duration-200 flex items-center justify-center overflow-hidden"
          >
            <p-avatar
              [image]="currentUser?.picture"
              [label]="currentUser.picture? null : currentUser?.username?.charAt(0)?.toUpperCase() || 'U'"
              size="normal"
              class="w-full h-full avatar-image"
              [style]="{ backgroundColor: 'transparent', color: 'var(--color-pink-500)' }"
            >
            </p-avatar>
          </button>

          <p-popover #userPopover styleClass="mobile-user-popover">
            <app-user-popover
              [currentUser]="currentUser"
              [currentUserBalance]="currentUserBalance"
              [balanceLoading]="balanceLoading"
              [isDark]="isDark"
              [currentLanguage]="currentLanguage"
              [availableLanguages]="availableLanguages"
              [appVersion]="appVersion"
              [userPopoverRef]="userPopover"
              (logoutClick)="onLogoutClick()"
              (languageSelect)="onLanguageSelect($event)"
            ></app-user-popover>
          </p-popover>
        </div>
      }
    </div>
  </div>
</header>
